import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { CurrentUser } from '../general/modules/user/currentUser';
import { ConsentSources } from '../constants/ConsentSources';
import { CustomJrpcErrResult } from '../general/modules/jsonRpc/jRpcErrResponse';
import { EmailConsentStates } from '../domains/valueObject/EmailConsentStates';

export type GetConsentStateRequest = {
    token: string,
    suid: string
}

export type GetConsentStateResponse = {
    consent: EmailConsentStates,
    email: string | null
};

export default class ConsentState {
    public setState(state: boolean, email: string, source: ConsentSources) {
        const currentUser = CurrentUser.getInstance();
        const token = currentUser.getAuthToken();
        const suid = currentUser.getSuid();
        const entryPoint = currentUser.getEntryPoint();

        return HubJsonRpcRequest.makeRequest(
            HubApiMethods.SET_CONSENT_STATE,
            {
                consent: state,
                source: source,
                email: email,
                entryPoint: entryPoint,
                suid: suid,
                token: token
            },
            window.app.deviceIdentifier
        );
    }

    public async getConsentState(): Promise<GetConsentStateResponse> {
        const currentUser = CurrentUser.getInstance();
        const token = currentUser.getAuthToken();
        const suid = currentUser.getSuid();

        const getConsentState: GetConsentStateResponse|CustomJrpcErrResult = await HubJsonRpcRequest.makeRequest<GetConsentStateResponse, GetConsentStateRequest>(
            HubApiMethods.GET_CONSENT_STATE,
            {
                token: token,
                suid: suid
            },
            window.app.deviceIdentifier
        );

        if ('error' in getConsentState) {
            throw new Error(getConsentState.error.message);
        }

        return getConsentState;
    }
}
